import React, { useState } from 'react';
import QuestionWrapper from '../../../wrappers/question_wrapper/index';

import styles from '../questionnaire.module.css';

export default function PatientGender({
  answers,
  onSubmit,
  onBack,
  title = 'What is your gender?',
  para = 'We find that patients and mentors who identify as the same gender form better connections.',
  choices = ['Male', 'Female', 'Non-binary'],
}) {
  const [gender, setGender] = useState(answers.gender || '');

  const onClick = (value) => () => {
    setGender(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && gender !== '') {
      onSubmit({ gender });
    }
  };

  return (
    <QuestionWrapper onSubmit={handleSubmit} onBack={onBack} isDisabled={!gender.length}>
      <h5 className={styles.question}>{title}</h5>
      <p className={styles.question_para}>{para}</p>
      {choices.map((choice) => (
        <div key={choice} className={`${styles.tile} ${styles.twoColumn}`}>
          <label
            key={choice}
            className={`${styles.preexisting} ${gender === choice ? `${styles.active_checkbox}` : ''}`}
          >
            <input id={`gender-${choice}`} onClick={onClick(choice)} type='checkbox' name={choice} value='value' />
            {choice}
          </label>
        </div>
      ))}
    </QuestionWrapper>
  );
}
